import { render, staticRenderFns } from "./microbialLoadTestingOfLAFU.vue?vue&type=template&id=195592dc&scoped=true&"
import script from "./microbialLoadTestingOfLAFU.vue?vue&type=script&lang=js&"
export * from "./microbialLoadTestingOfLAFU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195592dc",
  null
  
)

export default component.exports